import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgGezin = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <circle
      cx={14}
      cy={19}
      r={4}
      fill="#85E3F9"
    />
    <circle
      cx={25.5}
      cy={15.5}
      r={4.5}
      fill="#85E3F9"
    />
    <path
      fill="#85E3F9"
      fillRule="evenodd"
      d="M18 27a4 4 0 0 0-8 0v5h8zM30 25.333V32h-9v-6.667C21 22.388 23.015 20 25.5 20s4.5 2.388 4.5 5.333"
      clipRule="evenodd"
    />
    <circle
      cx={21.5}
      cy={23}
      r={3}
      fill="#00C5F2"
    />
    <path
      fill="#00C5F2"
      fillRule="evenodd"
      d="M23.989 29q.01-.124.011-.25a2.75 2.75 0 1 0-5.489.25H18.5v3H24v-3z"
      clipRule="evenodd"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgGezin);

export default ForwardRef;
